import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import App from "./App.vue";
import router from "@/router";
import pinia from "@/store";
import { useUserStore } from "@/store/modules/user";
import { scheduleRefresh } from "@/utils/request";
import "./styles/index.scss";

const app = createApp(App);

app.use(router);
app.use(pinia);
// Element Plus 全量引入：避免按需加载导致首次进入/切路由时动态拉取组件代码卡顿
app.use(ElementPlus, { locale: zhCn });

// 刷新页面后恢复主动续期定时器
const userStore = useUserStore();
if (userStore.token && userStore.expiresAt) {
  scheduleRefresh(userStore.expiresAt);
}

app.mount("#app");
